import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IUnidade } from '../interfaces/unidade/iunidade';
import { IUnitTaxInfo } from '../interfaces/unidade/iunittaxinfo';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnidadeService {
  filter!:IUnidadeFilter;
  //'url: string = `${environment.url}/units`
  //url: string = 'http://localhost:3000/units'
  url: string = `${environment.url}/units`

  params: any = {};

  constructor(private http: HttpClient) { }
    
  getAll(filter: string = "") {

    let queryParams: any;
    if(filter.length <= 0) {
      let urlParams = new URLSearchParams();
      urlParams.append('isActive','true');

      if(this.filter?.unitName) {
        urlParams.append('unitName',this.filter.unitName);
      }
      if(this.filter?.main != undefined) {
        urlParams.append('main',String(this.filter.main));
      }
      if(this.filter?.city) {
        urlParams.append('address.city',this.filter.city);
      }
      if(this.filter?.isActive != undefined && this.filter?.isActive != null) {
        urlParams.append('isActive',String(this.filter.isActive));
      }
      queryParams = urlParams.toString();
    } else {
      queryParams = filter;
    }

    return this.http
      .get(`${this.url}?itemsPerPage=154&${queryParams}`, {
        params: this.params
      })
      .pipe(map((res: any) => res['hydra:member'] )) as Observable<IUnidade[]>;
  }

  getById(id: number) {
    return this.http
      .get(`${this.url}/${id}`) as Observable<IUnidade>;
  }

  save(req: IUnidade) {
    return this.http.post(
      `${this.url}`,
      req
    ) as Observable<IUnidade>;
  }

  saveUnitTaxInfo(req: IUnitTaxInfo) {
    return this.http.post(
      'https://api-fake-r9p5.onrender.com/units_tax_info',
      req
    ) as Observable<IUnitTaxInfo>
  }

  editUnidade(req: IUnidade | IUnitTaxInfo, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${this.url}/${id}`,
      req,
      { headers: headers }
    ) as Observable<IUnidade>;
  }

  editUnitTaxInfo(req: IUnitTaxInfo | IUnidade, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });

    console.log('passou pelo unit tax info')
    return this.http.patch(
      `https://api-fake-r9p5.onrender.com/units_tax_info/${id}`,
      req,
      { headers: headers }
    ) as Observable<IUnitTaxInfo>;
  }



  delete(id: number) {
    return this.http.delete(
      `${this.url}/${id}`
    ) as Observable<IUnidade>;
  }

  setFilter(filter : IUnidadeFilter) {
    this.filter = filter;
  }

  setSearch(fields: string[], value: string) {
   let field = fields.join(",");
    this.params[`search[${field}]`] = `${value}`;
  }

  sendEmail( id: number, type: 'unit' | 'professional' ){
    let req = { 
      id : id,
      type: type
     } 
    return this.http.post(
      `${environment.url}/text/send-proof-life-link`,
      req
    ) as Observable<any>;
  }
  


}

export interface IUnidadeFilter {
  main: boolean | null, 
  unitName: string,
  city: string,
  isActive: boolean
}

export class UnidadeFilter {
  main!: boolean | null;
  unitName! : string;
  city!: string;
  isActive: boolean = true
}
